import { TripGrouping } from '../../lib/types/models/trip-grouping/trip-grouping'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripGrouping(id: number) {
  return restApiClient.url(constructApiUrl(API.tripGroupings.get.url, { id })).get<TripGrouping>()
}
